import {Breakpoints, styled} from '@volkswagen-onehub/components-core';
import React, {useContext} from 'react';
import useTrans from '../../../../hooks/use-trans';
import {
  TrackingContext,
  TrackingEvents,
} from '../../../../store/context/modules/TrackingContext';
import {useAppSelector} from '../../../../store/hooks';
import {Button} from '../../../Button';

const FootersContainer = styled.div`
  margin-top: ${(props) => props.theme.size.dynamic0040};
  display: flex;
  justify-content: center;
  column-gap: ${(props) => props.theme.size.dynamic0040};
  flex-direction: column;
  row-gap: ${(props) => props.theme.size.dynamic0040};
  align-items: center;

  @media screen and (min-width: ${Breakpoints.b560}px) {
    flex-direction: row;
  }
`;

export default () => {
  const trans = useTrans();

  const trackCtx = useContext(TrackingContext);

  const vehicle = useAppSelector((state) => state.vehicle.value);

  const onBookAppointment = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();

    if (vehicle) {
      trackCtx?.init(
        TrackingEvents.FILTER_SEARCH_RESULT_BUTTON_CLICK,
        (vehicle.model as string).toUpperCase(),
        (vehicle.model as string).toUpperCase() + '-BOOK-AN-APPOINTMENT-BUTTON',
        {
          name:
            (vehicle.model as string).toUpperCase() +
            ' BOOK AN APPOINTMENT BUTTON',
          url: trans.result_book_url,
        },
        {
          results: [(vehicle.model as string).toUpperCase()],
          numberOfResults: 1,
          filterlist: [
            {
              type: 'multi_value',
              name: 'CG',
              values: [vehicle.model as string],
            },
            {
              type: 'single_value',
              name: 'ESV',
              values: [vehicle.model as string],
            },
          ],
        },
        null,
        {
          name:
            (vehicle.model as string).toLowerCase() +
            '-process-result-book-an-appointment-button',
          number: 7,
          processComplete: true,
        },
      );
    }

    window.open(trans.result_book_url, '_blank');
  };

  return (
    <FootersContainer>
      {/* <CTA tag='button' emphasis='secondary' icon={<Printer variant='default' ariaLabel='Print Button' />} onClick={e => onPrint(e)}>{trans.result_print}</CTA> */}
      <Button
        tag="button"
        emphasis="primary"
        onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
          onBookAppointment(e)
        }
      >
        {trans.result_book}
      </Button>
    </FootersContainer>
  );
};
